// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"66abd88f","522":"9f12a22f"}[chunkId] + ".chunk.js";
};